/* Peptina v3 product page scripts */


// ---- Peptina v3 → Shopify cart binding ----
// Injected from product.peptina-v3.liquid via window.PEPTINA_V3_VARIANTS = {1:..., 3:..., 6:...}
(function () {
  function init() {
    var V = (window.PEPTINA_V3_VARIANTS) || {};
    var form = document.getElementById('peptina-v3-form');
    var input = document.getElementById('peptina-v3-variant-id');
    if (!form) return;

    document.querySelectorAll('.peptina-v3 .bundle').forEach(function (b) {
      b.addEventListener('click', function () {
        document.querySelectorAll('.peptina-v3 .bundle').forEach(function (x) {
          x.classList.remove('selected');
        });
        b.classList.add('selected');
        var id = b.getAttribute('data-id');
        if (V[id] && input) input.value = V[id];
      });
    });

    ['.peptina-v3 .cta', '.peptina-v3 .final-cta', '.peptina-v3 .mini-cta'].forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (btn) {
        btn.setAttribute('type', 'button');
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          form.submit();
        });
      });
    });

    document.querySelectorAll('.peptina-v3 button:not([type])').forEach(function (b) {
      b.setAttribute('type', 'button');
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();


// ---- Original v3 inline JS ----

// Bundle selection + sticky ATC sync
const stickyTitle = document.querySelector('.sticky-atc .mini-title');
const stickyPrice = document.querySelector('.sticky-atc .mini-price');
function syncSticky(b) {
  if (stickyTitle) stickyTitle.textContent = 'Peptina · ' + (b.dataset.name || '');
  if (stickyPrice) stickyPrice.innerHTML = (b.dataset.strike ? '<s>' + b.dataset.strike + '</s>' : '') + (b.dataset.price || '');
}
document.querySelectorAll('.bundle').forEach(b => {
  b.addEventListener('click', () => {
    document.querySelectorAll('.bundle').forEach(x => x.classList.remove('selected'));
    b.classList.add('selected');
    syncSticky(b);
  });
});
const initBundle = document.querySelector('.bundle.selected');
if (initBundle) syncSticky(initBundle);

// FAQ toggle
document.querySelectorAll('.faq-item').forEach(item => {
  item.querySelector('.faq-q').addEventListener('click', () => {
    item.classList.toggle('open');
  });
});

// Sticky ATC appear on scroll past hero
const sticky = document.getElementById('stickyAtc');
const hero = document.querySelector('.hero');
window.addEventListener('scroll', () => {
  if (window.scrollY > hero.offsetHeight) {
    sticky.classList.add('show');
  } else {
    sticky.classList.remove('show');
  }
});

// Timeline slider behavior
const timelineData = [
  {
    week: 'DAY 1',
    title: 'Your starting point.',
    stat: '',
    statLabel: '',
    desc: 'Dark circles still visible \u2014 this is your baseline. But the cold steel rollerball goes to work on contact: puffiness eases on the very first pass, and you feel the cooling the moment it touches skin. Underneath, GHK-Cu has already begun binding to the capillary walls.',
    img: 'https://cdn.shopify.com/s/files/1/0973/3842/5677/t/2/assets/young-timeline-1.jpg'
  },
  {
    week: 'WEEK 2\u20133',
    title: 'The shadow starts to lift.',
    stat: '82%',
    statLabel: 'noticed a reduction in dark circles by week 2',
    desc: 'The darkness is visibly lighter \u2014 not gone, but clearly lifting. The under-eye looks less see-through as GHK-Cu thickens the thin skin and reinforces the capillary walls beneath it. Puffiness stays down, and you start skipping concealer on your better mornings.',
    img: 'https://cdn.shopify.com/s/files/1/0973/3842/5677/t/2/assets/young-timeline-2.jpg'
  },
  {
    week: 'WEEK 8',
    title: 'Faded for good.',
    stat: '91%',
    statLabel: 'saw improvement in fine lines and wrinkles',
    desc: 'The under-eye shadow has faded \u2014 and because GHK-Cu rebuilt the skin and capillaries underneath, it stays faded. Puffiness is gone, fine lines have softened, and concealer is finally optional. From here, one bottle a month keeps the result locked in.',
    img: 'https://cdn.shopify.com/s/files/1/0973/3842/5677/t/2/assets/young-timeline-3.jpg'
  },
];

const slider = document.getElementById('timelineSlider');
const marks = document.querySelectorAll('.timeline-marks span');
function updateTimeline(i) {
  const d = timelineData[i];
  document.getElementById('tlWeek').textContent = d.week;
  document.getElementById('tlTitle').textContent = d.title;
  const statEl = document.getElementById('tlStat');
  if (d.stat) {
    statEl.innerHTML = `<strong>${d.stat}</strong> <span>${d.statLabel}</span>`;
    statEl.style.display = 'inline-block';
  } else {
    statEl.innerHTML = '';
    statEl.style.display = 'none';
  }
  document.getElementById('tlDesc').textContent = d.desc;
  document.getElementById('tlImg').src = d.img;
  document.getElementById('timelineImage').setAttribute('data-stage', i);
  // Update slider fill
  const pct = (i / 2) * 100;
  slider.style.setProperty('--fill', pct + '%');
  // Update active mark
  marks.forEach((m, idx) => m.classList.toggle('active', idx === i));
}
slider.addEventListener('input', (e) => updateTimeline(parseInt(e.target.value)));
marks.forEach((m, idx) => m.addEventListener('click', () => { slider.value = idx; updateTimeline(idx); }));
// Initialize
updateTimeline(parseInt(slider.value));

// Testimonial rotation (desktop social-proof-stack)
const testimonials = [
  { quote: "I had a tear-trough filler consult booked. I tried Peptina for two months first. My under-eyes lightened enough that I cancelled. Not looking back.", name: "Amanda K., 33", initial: "A" },
  { quote: "I've spent twenty years and a small fortune trying to fix my under-eyes. This is the first product that did anything structural. I'm almost annoyed it was this simple.", name: "Jessica T., 27", initial: "J" },
  { quote: "Three separate people asked if I'd had a treatment. I just told them the name of a roll-on. Best feeling.", name: "Priya N., 35", initial: "P" },
  { quote: "I stopped covering my under-eyes with concealer for the first time in 10 years. Nothing else I've tried actually did this.", name: "Sarah M., 30", initial: "S" }
];
let tmIdx = 0;
const tmQuoteEl = document.getElementById('tmQuote');
const tmNameEl = document.getElementById('tmName');
const tmAvatarEl = document.getElementById('tmAvatar');
function updateTm() {
  const t = testimonials[tmIdx];
  if (tmQuoteEl) tmQuoteEl.textContent = '"' + t.quote + '"';
  if (tmNameEl) tmNameEl.textContent = t.name;
  if (tmAvatarEl) {
    var avUrl = (window.PEPTINA_TM_AVATARS || {})[t.name];
    var imgEl = document.getElementById('tmAvatarImg');
    if (imgEl && avUrl) {
      imgEl.src = avUrl;
      tmAvatarEl.classList.add('has-photo');
    } else if (!imgEl) {
      tmAvatarEl.textContent = t.initial;
    }
  }
}
const tmPrev = document.getElementById('tmPrev');
const tmNext = document.getElementById('tmNext');
if (tmPrev) tmPrev.addEventListener('click', () => { tmIdx = (tmIdx - 1 + testimonials.length) % testimonials.length; updateTm(); });
if (tmNext) tmNext.addEventListener('click', () => { tmIdx = (tmIdx + 1) % testimonials.length; updateTm(); });
// Auto-rotate every 7 seconds
setInterval(() => { tmIdx = (tmIdx + 1) % testimonials.length; updateTm(); }, 7000);

// Peek carousel dot sync (mobile)
const heroImgBox = document.querySelector('.hero .img-box');
const heroDots = document.querySelectorAll('.mobile-dots .dot');
if (heroImgBox && heroDots.length) {
  const updateDots = () => {
    const firstSlide = heroImgBox.querySelector('.slide');
    if (!firstSlide) return;
    const slideWidth = firstSlide.offsetWidth + 10; // + gap
    const idx = Math.round(heroImgBox.scrollLeft / slideWidth);
    const clamped = Math.min(idx, heroDots.length - 1);
    heroDots.forEach((d, i) => d.classList.toggle('active', i === clamped));
    document.querySelectorAll('.left-col .thumbs .thumb').forEach((t, i) => t.classList.toggle('active', i === clamped));
  };
  heroImgBox.addEventListener('scroll', updateDots, { passive: true });
  heroDots.forEach((dot, i) => {
    dot.addEventListener('click', () => {
      const firstSlide = heroImgBox.querySelector('.slide');
      if (!firstSlide) return;
      const slideWidth = firstSlide.offsetWidth + 10;
      heroImgBox.scrollTo({ left: i * slideWidth, behavior: 'smooth' });
    });
  });
}

// Desktop drag-to-scroll for the testimonials carousel
(function () {
  const tg = document.querySelector('.test-grid');
  if (!tg) return;
  let down = false, startX = 0, startScroll = 0, moved = false;
  tg.addEventListener('mousedown', function (e) {
    if (window.innerWidth < 901) return;
    down = true; moved = false;
    startX = e.pageX; startScroll = tg.scrollLeft;
    tg.classList.add('dragging');
  });
  window.addEventListener('mouseup', function () { down = false; tg.classList.remove('dragging'); });
  window.addEventListener('mousemove', function (e) {
    if (!down) return;
    const dx = e.pageX - startX;
    if (Math.abs(dx) > 4) moved = true;
    tg.scrollLeft = startScroll - dx;
  });
  tg.addEventListener('click', function (e) {
    if (moved) { e.preventDefault(); e.stopPropagation(); }
  }, true);
})();

// Desktop product gallery -- clickable thumbnails + arrows + auto-rotate
(function () {
  const box = document.querySelector('.hero .img-box');
  if (!box) return;
  const slides = Array.from(box.querySelectorAll('.slide'));
  const thumbs = Array.from(document.querySelectorAll('.left-col .thumbs .thumb'));
  if (!slides.length) return;
  const total = slides.length;
  let current = slides.findIndex(function (s) { return s.classList.contains('active'); });
  if (current < 0) current = 0;
  let userInteracted = false;
  let autoTimer = null;

  function go(i) {
    current = (i + total) % total;
    slides.forEach(function (s, j) { s.classList.toggle('active', j === current); });
    thumbs.forEach(function (t, j) { t.classList.toggle('active', j === current); });
    box.scrollTo({ left: 0, behavior: 'auto' });
  }
  function startAuto() {
    stopAuto();
    autoTimer = setInterval(function () { if (!userInteracted) go(current + 1); }, 4500);
  }
  function stopAuto() { if (autoTimer) { clearInterval(autoTimer); autoTimer = null; } }
  function pauseAuto() { userInteracted = true; stopAuto(); }

  thumbs.forEach(function (t, i) {
    t.addEventListener('click', function () {
      pauseAuto();
      if (window.matchMedia('(max-width: 900px)').matches) {
        var slide = slides[i];
        if (slide) {
          box.scrollTo({ left: slide.offsetLeft - box.offsetLeft, behavior: 'smooth' });
        }
        thumbs.forEach(function (tt, j) { tt.classList.toggle('active', j === i); });
      } else {
        go(i);
      }
    });
  });

  const prev = document.querySelector('.hero .img-box .gallery-arrow-prev');
  const next = document.querySelector('.hero .img-box .gallery-arrow-next');
  if (prev) prev.addEventListener('click', function (e) { e.preventDefault(); pauseAuto(); go(current - 1); });
  if (next) next.addEventListener('click', function (e) { e.preventDefault(); pauseAuto(); go(current + 1); });

  /* auto-rotate disabled per user */
})();

// Desktop drag-to-scroll for the reviews carousel
(function () {
  const rg = document.querySelector('.rev-grid');
  if (!rg) return;
  let down = false, startX = 0, startScroll = 0, moved = false;
  rg.addEventListener('mousedown', function (e) {
    if (window.innerWidth < 901) return;
    down = true; moved = false;
    startX = e.pageX; startScroll = rg.scrollLeft;
    rg.classList.add('dragging');
  });
  window.addEventListener('mouseup', function () { down = false; rg.classList.remove('dragging'); });
  window.addEventListener('mousemove', function (e) {
    if (!down) return;
    const dx = e.pageX - startX;
    if (Math.abs(dx) > 4) moved = true;
    rg.scrollLeft = startScroll - dx;
  });
  rg.addEventListener('click', function (e) {
    if (moved) { e.preventDefault(); e.stopPropagation(); }
  }, true);
})();